require('abortcontroller-polyfill/dist/polyfill-patch-fetch')

export default
{
    props:
    {
        src: { type: String, default: '' },
        isAuto: { type: Boolean, default: true }
    },

    watch:
    {
        src: 'fetch'
    },

    created()
    {
        if(this.isAuto)
        {
            this.fetch()
        }
    },

    render(el)
    {
        return el()
    },

    methods:
    {
        fetch()
        {
            if(this.src === '')
            {
                return
            }

            if (this._controller)
            {
                this._controller.abort()
            }

            // if('AbortController' in window)
            // {
            //     this._controller = new AbortController
            //     this._signal = this._controller.signal
            // }

            this._controller = new AbortController
            this._signal = this._controller.signal

            const headers = new Headers()
            headers.set('Authorization', 'Basic ' + btoa('edouardfrancois' + ':' + '3vRrNLnSl47r'))

            fetch(this.src, { headers: headers, signal: this._signal }).then(this.handleErrors).then((response) =>
            {
                const contentType = response.headers.get('content-type')

                if(contentType && contentType.indexOf('application/json') !== -1)
                {
                    response.json().then((json) =>
                    {
                        this.$emit('data:loaded', json)
                    })
                }
            })
            .catch((error) =>
            {
                if(error.name === 'AbortError')
                {
                    // return
                }

                console.warn('error when fetching ' + this.src + ':\n' + error)
                this.$emit('data:error')
            })
        },

        handleErrors(response)
        {
            if(!response.ok)
            {
                throw Error(response.statusText)
            }

            return response
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/core-fetch/script.js